<template>
  <el-card class="box-card mt10">
    <div class="date-item">
      <el-link :type="orderType === 1?'primary':''" :underline="false">账户走向</el-link>

      <!-- <div class="order-today">
        <el-link :type="orderToday === 2?'warning':''" :underline="false" @click="handleOrderToday(2)">本周</el-link>
        <el-link :type="orderToday === 3?'warning':''" :underline="false" @click="handleOrderToday(3)">本月</el-link>
        <el-date-picker @change="changeDate" v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </div> -->
    </div>
    <div class="order-cont" v-if="orderMoney">
      <div>当前余额账户<br /><span>{{orderMoney.balance}}</span></div>
      <div>当前零售价账户<br /><span>{{orderMoney.xiaoduMoney}}</span></div>
      <div>当前赠送账户<br /><span>{{orderMoney.tuition}}</span></div>
    </div>
    <!-- <echarts-vue :echart-data="echartData" echartName="echarts" /> -->
  </el-card>
</template>

<script>
import echartsVue from './echarts.vue'
import homeStatisticsApi from '@/api/home'
import { getWeekDates, getMonthDates, formatDate, getDayAll } from '@/utils/index'
export default {
  props: ['eType'],
  components: { echartsVue },
  data() {
    return {
      dateTime: [],
      orderToday: 2, //2 本周 3 本月 自定义时间 10
      orderType: 1, // 账户走向类型
      echartsData: [],
      orderMoney: null,
      allDate: []
    }
  },
  created() {
    this.startTime = getWeekDates()[0]
    this.endTime = getWeekDates()[1]
    this.getfindCashMoney();
  },
  methods: {
    //现金金额统计
    getfindCashMoney() {
      homeStatisticsApi.findHomeAllUserWallet().then(({ data }) => {
        this.orderMoney = data;
      })
    },
    changeDate() {
      if (!this.dateTime) return
      if (this.dateTime && !this.dateTime.length) return
      this.orderToday = 10;
      this.startTime = this.dateTime[0]
      this.endTime = this.dateTime[1]
      this.getfindCashMoney();
    },
  }
}
</script>

<style lang="scss" scoped>
.date-item {
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .order-today {
    float: right;
  }
}
.order-cont {
  display: flex;
  margin: 20px 0;
  div {
    font-size: 16px;
    color: #000;
    width: 33.33%;
    display: inline-block;
    line-height: 50px;
    span {
      font-size: 40px;
    }
  }
}
.el-link {
  padding-right: 20px;
}
</style>